import {
  FormControl as FC,
  FormLabel as FL,
  Typography as TG,
  Button as Btn,
  FormHelperText as FHT
} from '@material-ui/core'
import styled, { css } from 'styled-components'
import { colors } from 'app/theme/colors'

export const Container = styled.div`
  margin: 15px 8px 8px 8px;
`

export const FormControl = styled(FC)`
  margin-bottom: 8px;
`

export const FormLabel = styled(FL)`
  margin-bottom: 3px !important;
`
export const Typography = styled(TG)`
  ${(props) =>
    css`
      ${props.$css}
    `}
`

export const Button = styled(Btn)`
  border-radius: 32px;
  padding: 8px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 10px;
  margin-top: 5px;
  .MuiButton-label {
    text-align: center;
    font-size: 16px;
    text-transform: lowercase;
  }
  background-color: ${colors.ohYellow};
  display: inline-block;
`

export const RedirectCTA = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
export const FieldGroup = styled.div`
  margin-bottom: 2px;
  flex: 1 1 0%;
  width: 100%;
`
export const FieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
`

export const Icon = styled.img`
  height: 24px;
  width: 24px;
  cursor: pointer;
  margin-left: 12px;
  flex-shrink: 0;
`
export const FormHelperText = styled(FHT)`
  color: #f44336;
`
